import {
  ANALYTICS_ACTION,
  performTrack,
} from '../scripts/analytics/tracker';

const analyticsMiddleware = ({ getState }) => next => action => {
  if (action.type === ANALYTICS_ACTION) {
    // perform actual tracking
    performTrack({
      state: getState(),
      ...(action.payload || {}),
    });
  }
  return next(action);
};


export default analyticsMiddleware;
